import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../../Context/AuthContext";
import { useForm } from "react-hook-form";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";
import EmailIcon from "@mui/icons-material/Email";
import { FcGoogle } from "react-icons/fc";
import { useGoogleLogin } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";




const Step1 = () => {

  const { nextStep, updateAdminInfo, setUser, user, profile, setProfile } = useAuthContext();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const clientId = "671164180097-m85hbtdcdv70dfo6i364llvv277dqpvi.apps.googleusercontent.com";
  // const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log('Login Failed:', error)
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;










  const onSubmit = async (data) => {
    console.log(data);
    try {
      await updateAdminInfo({ email: data.email.toLowerCase() });
      setSearchParams({ step: 2, email: data.email });
      nextStep();
    } catch (error) {
      console.error("Error during email sign-up:", error);
    }
  };
  const fetchProfile = async () => {
    if (user) {
      try {
        const res = await fetch(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        );

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        
        const data = await res.json();
        console.log(data)
        setProfile(data);
        nextStep();
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [user]);

  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[10px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
      <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div">
        <div className="py-[22px] w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
          <div className="space-y-2 sm:space-y-0 md:p-[30px] lg:px-[50px] xl:px-[30px] w-full">
            <div className="flex justify-center items-center">
              <img
                src={flowChangerLogo}
                alt="FlowChanger Logo"
                className="w-[120px]"
              />
            </div>
            {/* <h2 className='font-bold text-[30px] text-black'>SIGN UP</h2> */}
            <div className="mt-[12px]">
              <p className="mt-[10px] pb-2 text-[#8c8c8c] text-[14px] text-center">
                Please SignUp to Continue
              </p>
            </div>

            {/* <div className="flex justify-center items-center my-4">
          <div className="flex-grow mr-3 border-gray-300 border-t"></div>
          <div className="px-4 py-2 text-gray-500 text-center">or Sign Up with Email</div>
          <div className="flex-grow ml-3 border-gray-300 border-t"></div>
        </div> */}

            <form
              id="signup-form"
              className="space-y-2 sm:space-y-0 mt-4 sm:mt-0"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="relative mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                  className="login-input-field"
                  {...register("email", { required: "email is required" })}
                />
                {errors.email && (
                  <p className="ml-2 text-red-500 text-xs">
                    {errors.email.message}
                  </p>
                )}
                <EmailIcon className="top-[10px] right-[13px] absolute text-[#8a25b0] email-icon" />
              </div>
            </form>

            {/* Buttons in row container */}
            <div className="flex flex-row justify-between items-center gap-[10px] md:gap-2 w-full signupbuttons">
              <button
                type="submit"
                form="signup-form"
                className="bg-[#8a25b0] px-4 py-[8px] border border-[#8a25b1] rounded-full w-1/2 font-medium text-[#fff] text-center free-signup"
              >
                Sign Up For Free
              </button>
              <button onClick={login} className={`font-medium text-[#8a25b0] text-center w-full md:w-[50%]  bg-[#8a25b1] border-[#8a25b0] rounded-full border  py-[8px] px-4 ${isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#8a25b0]"
                } text-white py-[8px] px-4 hover:bg-[#884a9f] transition duration-300 rounded-full`}
              >Sign up with Google </button>


            </div>
            <div className="flex justify-center items-center space-x-2 py-4">
              <p className="mb-0 text-[#8c8c8c]">Already have an account?</p>
              <Link
                to="/authentication/login"
                className="text-[#8a25b0] hover:text-purple-700"
              >
                Login
              </Link>
            </div>
          </div>
        </div>

        {/* Right side illustration */}
        <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
              Very good works are waiting for you SignUp Now!!!
            </h2>
            <div className="top-[-6px] right-[-42px] bottom-0 absolute">
              <img src={loginLady} alt="loginLady" className="h-[100%]" />
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1;